import { Component, OnInit, Inject, ViewContainerRef, ViewChild, ComponentRef, ComponentFactoryResolver, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IModalConfig } from './modal.config';

@Component({
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnInit, OnDestroy {

    headerTitle = 'Information';
    hideFooter = false;

    @ViewChild('target', { read: ViewContainerRef, static: true }) vcRef: ViewContainerRef;
    componentRef: ComponentRef<any>;

    constructor(
        private dialogRef: MatDialogRef<ModalComponent>,
        private resolver: ComponentFactoryResolver,
        @Inject(MAT_DIALOG_DATA) private data: IModalConfig
    ) {
        this.headerTitle = this.data.headerTitle ? this.data.headerTitle : this.headerTitle;
        this.hideFooter = this.data.hideFooter ? !!this.data.hideFooter : this.hideFooter;
    }

    ngOnInit() {
        if (this.data.component) {
            const factory = this.resolver.resolveComponentFactory(this.data.component);
            this.componentRef = this.vcRef.createComponent(factory);

            // Listen to closing event
            if (this.componentRef.instance.componentClose) {
                this.componentRef.instance.componentClose.subscribe((value) => {
                    if (value) {
                        this.dialogRef.close(value);
                    } else {
                        this.dialogRef.close();
                    }
                });
            }

            // Pass data to child component
            if (this.data.componentData) {
                this.componentRef.instance.data = this.data.componentData;
            }
        }
    }

    ngOnDestroy(): void {
        if (this.componentRef) {
            this.componentRef.destroy();
        }
    }

}
